import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';
import { AnyIfEmpty, useDispatch } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import TextInput from '../../common/input/textInput/TextInput';
import PhoneInput, { CountryData } from 'react-phone-input-2';
import TextArea from '../../common/input/textArea/TextArea';
import DatePicker from 'react-datepicker';
import { AppDispatch, IRootState } from '../../../redux/rootReducer';
import { trimData } from '../../../utils/trim-data';
import { CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js';
import Loader from '../../common/loader/Loader';
import 'react-datepicker/dist/react-datepicker.css';
import styles from './AddVendorsAppointment.module.css';
import { colourStyles, REGEX } from '../../../constants/constants';
import Select from 'react-select';
import { getVendorLockerList, resetVendorLockerListState, VendorLockerListParams } from '../../../redux/vendor-locker-list/actions/vendorLockerList.action';
import { useSelector } from 'react-redux';
import OutlinedCloseIcon from '../../svgIcons/OtlinedCloseIcon';
import { createVendorAppointment, editVendorAppointment } from '../../../redux/vendor/actions/vendor.action';
// Removed getVendor import - using different logic
// import { getVendor } from '../../../redux/vendor/actions/vendors.action';
import { locationsData } from '../../locations/Locations';
import { getLocation } from '../../../redux/location/actions/location.action';
import { getVendorsByLocation, resetVendorsByLocationState } from '../../../redux/vendor/actions/vendorsByLocation.action';

interface vendorsProps {
    setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
    locationId?: string;
    locationName?: string;
    vendorData?: AnyIfEmpty<object>;
    setShowToast?: React.Dispatch<React.SetStateAction<boolean>>;
    setToastMessage?: React.Dispatch<React.SetStateAction<string>>;
    setToastType?: React.Dispatch<React.SetStateAction<string>>;
    onSuccess?: () => void;
}
interface addVendorsValues {
    vendor: string;
    propertyName: string;
    vendorPhone?: string;
    vendorEmail?: string;
    vendorSpecialNote: string;
    startDate: Date | string | null;
    endDate: Date | string | null;
    startTime: string;
    endTime: string;
    locker: string | null;
    allowStratEndTimeEachDay: boolean,
    allowEntireTimeBlock: boolean,
}

export function validatePhone(number: string, countryCode: CountryCode) {
    const phoneNumber = parsePhoneNumberFromString(number, countryCode);
    return phoneNumber?.isValid() || false;
}

interface vendorOptionsProps {
    "id": string;
    name: string;
    email: string;
    phone: string;
    accessCode: string;
}

const DISPLAY_DATE_FORMAT = 'MM-DD-YYYY';
const API_DATE_FORMAT = 'YYYY-MM-DD';
const VENDOR_API_DATE_FORMAT = 'DD-MM-YYYY';

const parseVendorAppointmentDate = (
    value: Date | string | null | undefined,
    formats = [DISPLAY_DATE_FORMAT, API_DATE_FORMAT, VENDOR_API_DATE_FORMAT, moment.ISO_8601]
) => {
    if (!value) return null;

    if (value instanceof Date) {
        const parsedDate = moment(value);
        return parsedDate.isValid() ? parsedDate : null;
    }

    const parsedDate = moment(value, formats, true);
    return parsedDate.isValid() ? parsedDate : null;
};

const vendorAppointmentDateToDate = (value: Date | string | null | undefined) => {
    return parseVendorAppointmentDate(value)?.toDate() || null;
};

const formatVendorAppointmentDateForApi = (value: Date | string | null | undefined) => {
    return parseVendorAppointmentDate(value)?.format(API_DATE_FORMAT) || '';
};

const formatVendorAppointmentDateForForm = (value: Date | string | null | undefined) => {
    return parseVendorAppointmentDate(value, [VENDOR_API_DATE_FORMAT, API_DATE_FORMAT, DISPLAY_DATE_FORMAT, moment.ISO_8601])
        ?.format(DISPLAY_DATE_FORMAT) || '';
};

const AddVendorsAppointment = ({ setOpen, locationId, locationName, vendorData, setShowToast, setToastMessage, setToastType, onSuccess }: vendorsProps) => {
    const params = useParams();
    const { id: location_id } = params;
    const dispatch: AppDispatch = useDispatch();
    const { data: lockers, error: lockersError, loading: lockerDataLoading } = useSelector((state: IRootState) => state.vendorLockerListReducer);
    const { data: vendorsByLocationData, loading: loadingVendorsByLocation } = useSelector((state: IRootState) => state?.vendorsByLocationReducer);
    const allLocationsList = useSelector((state: IRootState) => state.locationReducer.data.locations);
    const invitedLocations = useSelector((state: IRootState) => state.locationReducer.data?.locationinvitedlist);
    const locationLoading = useSelector((state: IRootState) => state.locationReducer.loading);
    const [locations, setLocations] = useState<locationsData[]>([]);
    const page = 5;
    const limit = 10;
    const navigate = useNavigate();
    const isEditMode = !!vendorData;
    const [phoneNumberLength, setPhoneNumberLength] = useState(11);
    const [loading, setLoading] = useState(false);
    const [availableLockers, setAvailableLockers] = useState<number[]>([]);
    const [dialCodeLength, setDialCodeLength] = useState(0);
    const [missingFieldsMessage, setMissingFieldsMessage] = useState<string>('');
    const [vendorOptions, setVendorOptions] = useState<vendorOptionsProps[]>([]);
    const [isEditModeInitializing, setIsEditModeInitializing] = useState(false);

    useEffect(() => {
        if (location_id && !locationLoading && locations && locations?.length) {
            const property = locations?.find((location: locationsData) => location?.id === location_id);
            if (property && property?.id) {
                setValue('propertyName', property?.id);
                fetchVendorsByLocation(location_id || "");
            }
        }

    }, [location_id, locations, locationLoading]);

    useEffect(() => {
        if (vendorsByLocationData) {
            setVendorOptions(vendorsByLocationData);
        }
    }, [vendorsByLocationData]);

    useEffect(() => {
        if (missingFieldsMessage) {
            setTimeout(() => {
                setMissingFieldsMessage('');
            }, 4000);
        }
    }, [missingFieldsMessage]);

    useEffect(() => {
        dispatch(getLocation())

        return () => {
            dispatch(resetVendorLockerListState());
            setAvailableLockers([]);
            setValue("locker", null);
            setVendorOptions([]);
            dispatch(resetVendorsByLocationState());
        }
    }, [])

    useEffect(() => {
        if (!invitedLocations?.length && !allLocationsList?.length) {
            setLocations([]);
        } else {
            if (invitedLocations?.length || allLocationsList?.length) {
                const data = invitedLocations?.map((list: locationsData) => {
                    return {
                        ...list,
                        isRestricted: true,
                    };
                });
                setLocations([...data, ...allLocationsList]);
            }
        }
    }, [allLocationsList?.length, invitedLocations?.length]);

    const {
        handleSubmit,
        control,
        formState: { errors },
        reset,
        watch,
        setValue,
        trigger,
        getValues,
    } = useForm<addVendorsValues>({
        defaultValues: {
            vendor: '',
            propertyName: locationName,
            vendorPhone: '',
            vendorEmail: '',
            vendorSpecialNote: '',
            startDate: null,
            endDate: null,
            startTime: '',
            endTime: '',
            locker: null,
            allowStratEndTimeEachDay: true,
            allowEntireTimeBlock: false,
        },
        mode: 'onChange',
        reValidateMode: 'onChange',
    });

    useEffect(() => {
        if (vendorData && vendorData?.id) {
            setIsEditModeInitializing(true);
            reset({
                vendor: vendorData.vendorName || '',
                propertyName: '',
                vendorPhone: vendorData.vendorPhone || '',
                vendorEmail: vendorData.vendorEmail || '',
                vendorSpecialNote: vendorData.vendorSpecialNote || '',
                startDate: formatVendorAppointmentDateForForm(vendorData.startDate),
                startTime: moment(vendorData.startTime, 'hh:mm a').format('hh:mm A') || '',
                endDate: formatVendorAppointmentDateForForm(vendorData.endDate),
                endTime: moment(vendorData.endTime, 'hh:mm a').format('hh:mm A') || '',
                locker: vendorData.locker ? String(vendorData.locker) : null,
                allowEntireTimeBlock: Boolean(vendorData.allowEntireTimeBlock) || false,
                allowStratEndTimeEachDay: Boolean(vendorData.allowStratEndTimeEachDay) || false,
            });
        }
    }, [vendorData]);

    useEffect(() => {
        if (vendorData && vendorData?.locationId && locations?.length && !locationLoading) {
            const location = locations.find((location: locationsData) => location.id === vendorData.locationId);
            if (location && location.id) {
                setValue('propertyName', location.id);
                fetchVendorsByLocation(location.id);
            }
        }
    }, [vendorData, locations, locationLoading]);

    useEffect(() => {
        if (vendorData && vendorData?.vendorId && vendorOptions?.length && !loadingVendorsByLocation) {
            const vendor = vendorOptions.find((opt: vendorOptionsProps) => opt.id === vendorData.vendorId);
            if (vendor && vendor.id) {
                setValue('vendor', vendor.id);
            }
            setIsEditModeInitializing(false);
        }
    }, [vendorData, vendorOptions, loadingVendorsByLocation]);

    useEffect(() => {
        if (isEditModeInitializing && vendorData && !vendorData?.vendorId && !vendorData?.locationId) {
            setIsEditModeInitializing(false);
        }
    }, [isEditModeInitializing, vendorData]);

    // Fallback timeout to ensure loader doesn't stay on indefinitely
    useEffect(() => {
        if (isEditModeInitializing) {
            const timeout = setTimeout(() => {
                setIsEditModeInitializing(false);
            }, 5000); // 5 second timeout

            return () => clearTimeout(timeout);
        }
    }, [isEditModeInitializing]);

    const startDate = watch("startDate");
    const endDate = watch("endDate");
    const startTime = watch("startTime");
    const endTime = watch("endTime");
    const allowEntireTimeBlock = watch("allowEntireTimeBlock");
    const allowStratEndTimeEachDay = watch("allowStratEndTimeEachDay");

    // Comprehensive validation function for fetchLockers
    const validateFetchLockersConditions = () => {
        const errors: string[] = [];
        // Check if all required fields have values
        if (!startDate) errors.push("Start date is required");
        if (!endDate) errors.push("End date is required");
        if (!startTime) errors.push("Start time is required");
        if (!endTime) errors.push("End time is required");
        if (!locationId && !watch('propertyName')?.toString()) errors.push("Location ID is required");

        // If any basic required fields are missing, return early
        if (errors.length > 0) {
            console.warn("Missing required fields:", errors.join(", "));
            return { isValid: false, errors };
        }

        // Validate date format first
        if (!parseVendorAppointmentDate(startDate)) {
            errors.push("Invalid start date format");
        }

        if (!parseVendorAppointmentDate(endDate)) {
            errors.push("Invalid end date format");
        }

        // Validate time format
        if (!moment(startTime, "hh:mm a", true).isValid()) {
            errors.push("Invalid start time format");
        }

        if (!moment(endTime, "hh:mm a", true).isValid()) {
            errors.push("Invalid end time format");
        }

        // If format validation fails, return early
        if (errors.length > 0) {
            return { isValid: false, errors };
        }

        // Validate date logic
        const startDateMoment = parseVendorAppointmentDate(startDate)!;
        const endDateMoment = parseVendorAppointmentDate(endDate)!;
        const today = moment().startOf("day");

        // Check if start date is not in the past
        if (startDateMoment.isBefore(today)) {
            errors.push("Start date cannot be in the past");
        }

        // Check if end date is not in the past
        if (endDateMoment.isBefore(today)) {
            errors.push("End date cannot be in the past");
        }

        // Check if end date is after or same as start date
        if (endDateMoment.isBefore(startDateMoment, "day")) {
            errors.push("End date must be same or after start date");
        }

        // 🟢 New validation: if start date is today, start time must be in the future
        if (startDateMoment.isSame(moment(), "day")) {
            const startTimeMoment = moment(startTime, "hh:mm a");
            const now = moment();
            if (startTimeMoment.isSameOrBefore(now, "minute")) {
                errors.push("Start time must be in the future");
            }
        }

        // Validate time logic based on the selected option
        if (allowEntireTimeBlock) {
            // For allowEntireTimeBlock: validate time difference for same day
            const isSameDay = startDateMoment.isSame(endDateMoment, "day");

            if (isSameDay) {
                const startTimeMoment = moment(startTime, "hh:mm a");
                const endTimeMoment = moment(endTime, "hh:mm a");
                const diffInMinutes = endTimeMoment.diff(startTimeMoment, "minutes");

                if (diffInMinutes <= 0) {
                    errors.push("End time must be after start time for same day");
                } else if (diffInMinutes < 60) {
                    errors.push("Time difference must be at least 1 hour for same day when using entire time block");
                }
            }
            // For different days, no time validation needed for allowEntireTimeBlock
        } else if (allowStratEndTimeEachDay) {
            // For allowStratEndTimeEachDay: validate time difference (always required)
            const startTimeMoment = moment(startTime, "hh:mm a");
            const endTimeMoment = moment(endTime, "hh:mm a");
            const diffInMinutes = endTimeMoment.diff(startTimeMoment, "minutes");

            if (diffInMinutes <= 0) {
                errors.push("End time must be after start time");
            } else if (diffInMinutes < 60) {
                errors.push("Time difference must be at least 1 hour when applying times to each day");
            }
        } else {
            // Neither option is selected
            errors.push("Please select either 'Apply Start/End Times to Each Day' or 'Allow Access for Entire Timeblock'");
        }

        return {
            isValid: errors.length === 0,
            errors,
        };
    };


    useEffect(() => {
        dispatch(resetVendorLockerListState());
        setAvailableLockers([]);
        setValue("locker", null);

        const fetchLockers = async () => {
            const validation = validateFetchLockersConditions();
            if (!validation.isValid) {
                dispatch(resetVendorLockerListState());
                setAvailableLockers([]);
                setValue("locker", null);
                return;
            }

            if (startDate && endDate) {
                const start = parseVendorAppointmentDate(startDate)!;
                const end = parseVendorAppointmentDate(endDate)!;
                if (end.isBefore(start, "day")) {
                    console.warn("End date must be the same or after start date");
                    return;
                }
            }

            if (startDate && endDate && startTime && endTime && (locationId || watch('propertyName')?.toString())) {
                try {
                    if (allowEntireTimeBlock && (locationId || watch('propertyName')?.toString())) {
                        const params: VendorLockerListParams = {
                            locationId: locationId || watch('propertyName')?.toString(),
                            startDate: formatVendorAppointmentDateForApi(startDate),
                            endDate: formatVendorAppointmentDateForApi(endDate),
                            startTime: moment(startTime, "hh:mm A").format("hh:mm A"),
                            endTime: moment(endTime, "hh:mm A").format("hh:mm A"),
                            allowEntireTimeBlock: allowEntireTimeBlock,
                            allowStratEndTimeEachDay: allowStratEndTimeEachDay,
                        };
                        if (isEditMode && vendorData?.id) {
                            params.vendorId = vendorData.id;
                        }

                        await dispatch(getVendorLockerList(params))
                    } else if (allowStratEndTimeEachDay && (locationId || watch('propertyName')?.toString())) {
                        const formattedStartDate = formatVendorAppointmentDateForApi(startDate);
                        const formattedStartTime = moment(startTime, "hh:mm a").format("hh:mm A");
                        const formattedEndDate = formatVendorAppointmentDateForApi(endDate);
                        const formattedEndTime = moment(endTime, "hh:mm a").format("hh:mm A");

                        const params: VendorLockerListParams = {
                            locationId: locationId || watch('propertyName')?.toString(),
                            startDate: formattedStartDate,
                            startTime: formattedStartTime,
                            endDate: formattedEndDate,
                            endTime: formattedEndTime,
                            allowEntireTimeBlock: allowEntireTimeBlock,
                            allowStratEndTimeEachDay: allowStratEndTimeEachDay,
                        };
                        if (isEditMode && vendorData?.id) {
                            params.vendorId = vendorData.id;
                        }

                        await dispatch(getVendorLockerList(params))
                    }
                } catch (error) {
                    console.error("Failed to fetch lockers", error);
                    setAvailableLockers([]);
                }
            }
        };

        fetchLockers();
    }, [startDate, endDate, startTime, endTime, allowEntireTimeBlock, allowStratEndTimeEachDay, locationId, dispatch, watch('propertyName')?.toString()]);

    useEffect(() => {
        if (lockersError && setShowToast && setToastType && setToastMessage) {
            setShowToast(true);
            setToastType("error");
            setToastMessage(lockersError);

            setTimeout(() => {
                setShowToast(false);
                setToastType('');
                setToastMessage('');
            }, 4000000);
        }
    }, [lockersError]);

    useEffect(() => {
        if (!lockerDataLoading && lockers) {
            setAvailableLockers(lockers || []);
            if (lockers) {
                setValue("locker", vendorData?.locker ? String(vendorData.locker) : null);
            }
        }
    }, [lockers, lockerDataLoading]);

    // Trigger validation when time fields change to update time picker slots
    useEffect(() => {
        if (startTime) {
            trigger('startTime');
        }
        if (endTime) {
            trigger('endTime');
        }
    }, [startTime, endTime, allowEntireTimeBlock, allowStratEndTimeEachDay, startDate, endDate, trigger]);


    const handleTrimStartChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        onChange: (value: string) => void
    ) => {
        const trimmedValue = e.target.value.trimStart();
        onChange(trimmedValue);
    };

    const editVendorSuccess = (message: string) => {
        if (setShowToast && setToastType && setToastMessage) {
            setShowToast(true);
            setToastType('success');
            setToastMessage(message);
            onSuccess?.()
            closeModal();
        }
    }

    const editVendorFailure = (message: string) => {
        setLoading(false)
        if (setShowToast && setToastType && setToastMessage) {
            setShowToast(true);
            setToastType('error');
            setToastMessage(message);
        }
    }

    const createVendorSuccess = (message: string) => {
        if (setShowToast && setToastType && setToastMessage) {
            setShowToast(true);
            setToastType('success');
            setToastMessage(message);
            closeModal();
            onSuccess?.()
        }
    }

    const createVendorFailure = (message: string) => {
        if (setShowToast && setToastType && setToastMessage) {
            setShowToast(true);
            setToastType('error');
            setToastMessage(message);
        }
    }

    // Helper function to check if time slot is valid based on conditions
    const isTimeSlotValid = (time: Date, isStartTime = true) => {
        if (!startDate || !endDate) return true;

        const currentTime = moment(time);
        const startDateMoment = parseVendorAppointmentDate(startDate);
        const endDateMoment = parseVendorAppointmentDate(endDate);
        if (!startDateMoment || !endDateMoment) return true;
        const isSameDay = startDateMoment.isSame(endDateMoment, 'day');

        // For allowEntireTimeBlock
        if (allowEntireTimeBlock) {
            if (isSameDay) {
                // Same day: need 1 hour difference between start and end time
                if (isStartTime) {
                    // For start time, check if there's a valid end time that's at least 1 hour later
                    if (endTime) {
                        const endTimeMoment = moment(endTime, 'hh:mm a');
                        const diffInMinutes = endTimeMoment.diff(currentTime, 'minutes');
                        return diffInMinutes >= 60;
                    }
                } else {
                    // For end time, check if there's a valid start time that's at least 1 hour earlier
                    if (startTime) {
                        const startTimeMoment = moment(startTime, 'hh:mm a');
                        const diffInMinutes = currentTime.diff(startTimeMoment, 'minutes');
                        return diffInMinutes >= 60;
                    }
                }
            }
            // Different days: no time validation needed
            return true;
        }

        // For allowStratEndTimeEachDay
        if (allowStratEndTimeEachDay) {
            if (isStartTime) {
                // For start time, check if there's a valid end time that's at least 1 hour later
                if (endTime) {
                    const endTimeMoment = moment(endTime, 'hh:mm a');
                    const diffInMinutes = endTimeMoment.diff(currentTime, 'minutes');
                    return diffInMinutes >= 60;
                }
            } else {
                // For end time, check if there's a valid start time that's at least 1 hour earlier
                if (startTime) {
                    const startTimeMoment = moment(startTime, 'hh:mm a');
                    const diffInMinutes = currentTime.diff(startTimeMoment, 'minutes');
                    return diffInMinutes >= 60;
                }
            }
        }

        return true;
    }

    // Helper function to filter time slots
    const filterTimeSlots = (time: Date) => {
        return isTimeSlotValid(time, true);
    }

    // Helper function to filter end time slots
    const filterEndTimeSlots = (time: Date) => {
        return isTimeSlotValid(time, false);
    }

    const submitHandler = async (data: addVendorsValues) => {
        const trim = (val: string) => trimData<string>(val) || '';
        const startDateTime = data.startDate && data.startTime
            ? moment(`${formatVendorAppointmentDateForApi(data.startDate)} ${data.startTime}`, `${API_DATE_FORMAT} hh:mm a`)
            : null;

        const endDateTime = data.endDate && data.endTime
            ? moment(`${formatVendorAppointmentDateForApi(data.endDate)} ${data.endTime}`, `${API_DATE_FORMAT} hh:mm a`)
            : null;

        if (startDateTime && endDateTime) {
            const diffInMinutes = endDateTime.diff(startDateTime, 'minutes');
            if (diffInMinutes < 60) {
                toast.error('Appointment time must be at least 1 hour long');
                return;
            }
        }
        const phoneDigits = data.vendorPhone?.replace(/\D/g, '') || '';
        const actualPhone =
            phoneDigits.length > (dialCodeLength || 0)
                ? data.vendorPhone
                : '';

        const payload = {
            vendor: trim(data.vendor) || '',
            location: locationId || watch('propertyName')?.toString() || '',
            vendorSpecialNote: trim(data.vendorSpecialNote) || '',
            startDate: formatVendorAppointmentDateForApi(data.startDate),
            endDate: formatVendorAppointmentDateForApi(data.endDate),
            startTime: data.startTime ? moment(data.startTime, 'hh:mm a').format('hh:mm A') : '',
            endTime: data.endTime ? moment(data.endTime, 'hh:mm a').format('hh:mm A') : '',
            locker: Number(data.locker),
            allowStratEndTimeEachDay: Boolean(data.allowStratEndTimeEachDay),
            allowEntireTimeBlock: Boolean(data.allowEntireTimeBlock),
        }

        if (isEditMode && vendorData) {
            setLoading(true);
            await dispatch(editVendorAppointment(vendorData.id, payload, editVendorSuccess, editVendorFailure, navigate));
        } else {
            await dispatch(createVendorAppointment(payload, setLoading, createVendorSuccess, createVendorFailure));
        }
    }

    const closeModal = () => {
        if (setOpen) setOpen(false);
    };

    const fetchVendorsByLocation = (locationId: string) => {
        if (locationId) {
            dispatch(getVendorsByLocation({ locationId }));
        }
    }

    return (
        <div className={styles.modalAddStaff}>
            {(loading || isEditModeInitializing) && <Loader />}

            <div className={styles.modalHeader}>
                <div className={styles.modalTitle}>
                    <h4>{`${isEditMode ? 'Edit' : 'Create'} Vendor Appointment`}</h4>
                </div>
                <div className={styles.close} onClick={closeModal}>
                    <OutlinedCloseIcon />
                </div>
            </div>

            <div className={styles.modalBody}>
                <form onSubmit={handleSubmit(submitHandler)}>
                    <div className={styles.row}>
                        <div className={`${styles.fieldWrapper} ${styles.lockerWrapper}`}>
                            <label>
                                Property Name
                            </label>
                            <span className={styles.astrikSign}> *</span>
                            <Controller
                                name="propertyName"
                                control={control}
                                rules={{
                                    required: "Property is required",
                                }}
                                render={({ field: { value, onChange } }) => {
                                    const options = locations.map((loc) => ({
                                        value: loc.id ?? "",
                                        label: loc.name ?? "",
                                    }));

                                    return (
                                        <Select
                                            isLoading={locationLoading}
                                            isMulti={false}
                                            isDisabled={(location_id || isEditMode) ? true : false}
                                            backspaceRemovesValue
                                            placeholder="Select Property"
                                            maxMenuHeight={170}
                                            styles={colourStyles}
                                            options={options}
                                            value={options.find((option) => option.value === value) || null}
                                            onChange={(option) => {
                                                onChange(option?.value || ""); // update RHF state
                                                setValue('vendor', '');
                                                setValue('vendorPhone', '');
                                                setValue('vendorEmail', '');
                                                fetchVendorsByLocation(option?.value?.toString() || "");
                                            }}
                                            isSearchable
                                        />
                                    );
                                }}
                            />


                            {errors?.propertyName?.message && <p className={styles.errorMsg}>{errors?.propertyName?.message}</p>}
                        </div>
                        <div className={`${styles.fieldWrapper} ${styles.lockerWrapper}`}>
                            <label>
                                Vendor Name
                            </label>
                            <span className={styles.astrikSign}> *</span>
                            <Controller
                                name="vendor"
                                control={control}
                                rules={{
                                    required: 'Vendor is required',
                                }}
                                render={({ field: { value, onChange }, fieldState: { error } }) => (
                                    <Select
                                        isMulti={false}
                                        isLoading={false}
                                        backspaceRemovesValue
                                        placeholder={watch('propertyName') ? "Select Vendor" : "Select Property First"}
                                        maxMenuHeight={170}
                                        styles={colourStyles}
                                        options={vendorOptions?.map((opt) => ({
                                            value: opt.id,
                                            label: opt.name,
                                        }))}
                                        value={vendorOptions?.find((opt: vendorOptionsProps) => opt.id === value) ? {
                                            value: vendorOptions.find((opt: vendorOptionsProps) => opt.id === value)!.id,
                                            label: vendorOptions.find((opt: vendorOptionsProps) => opt.id === value)!.name
                                        } : null}
                                        onChange={(option) => {
                                            onChange(option?.value);
                                            const vendor = vendorOptions.find((opt: vendorOptionsProps) => opt.id === option?.value);
                                            if (vendor) {
                                                setValue('vendorPhone', vendor.phone);
                                                setValue('vendorEmail', vendor.email);
                                            }
                                        }}
                                        isSearchable={true}
                                        isDisabled={!watch('propertyName') || isEditMode}
                                    />
                                )}
                            />
                            {errors?.vendor?.message && <p className={styles.errorMsg}>{errors?.vendor?.message}</p>}
                        </div>

                    </div>

                    <div className={styles.row}>
                        <div className={styles.fieldWrapper}>
                            <label>Phone Number</label>
                            <Controller
                                name="vendorPhone"
                                control={control}
                                render={({ field: { value, onChange } }) => (
                                    <PhoneInput
                                        country={'us'} // default
                                        value={value || ''}
                                        disabled={true}
                                        inputStyle={{
                                            marginLeft: '30px',
                                            padding: '10px 14px',
                                            borderRadius: '8px',
                                            width: '92%',
                                            height: '48px',
                                        }}
                                        inputProps={{
                                            maxLength: phoneNumberLength,
                                            autoFocus: false,
                                        }}
                                        countryCodeEditable={false}
                                        enableLongNumbers={true}
                                        enableSearch
                                    />
                                )}
                            />
                            {errors?.vendorPhone && <p className={styles.errorText}>{errors?.vendorPhone.message?.toString()}</p>}
                        </div>
                        <div className={styles.fieldWrapper}>
                            <label>Vendor Email</label>
                            <Controller
                                name="vendorEmail"
                                control={control}

                                render={({ field }) => (
                                    <TextInput
                                        {...field}
                                        disabled={true}
                                    />
                                )}
                            />
                        </div>
                    </div>

                    {/* Radio Button */}
                    <div className={styles.radioGroup}>
                        <div className={styles.fieldWrapper}>
                            <Controller
                                name="allowStratEndTimeEachDay"
                                control={control}
                                defaultValue={true}
                                render={({ field }) => (
                                    <div className={styles.radioContainer}>
                                        <label className={styles.radio}>
                                            <input
                                                type="radio"
                                                name="timeAccessOption"
                                                checked={field.value}
                                                onChange={(e) => {
                                                    field.onChange(e.target.checked);
                                                    setValue('allowEntireTimeBlock', !e.target.checked);
                                                }}
                                            />
                                            <div className={styles.radioCheckmark}></div>
                                            <div className={styles.radioLabel}>Apply Start/End Times to Each Day</div>
                                        </label>
                                    </div>
                                )}
                            />
                        </div>
                        <div className={styles.fieldWrapper}>
                            <Controller
                                name="allowEntireTimeBlock"
                                control={control}
                                defaultValue={false}
                                render={({ field }) => (
                                    <div className={styles.radioContainer}>
                                        <label className={styles.radio}>
                                            <input
                                                type="radio"
                                                name="timeAccessOption"
                                                checked={field.value}
                                                onChange={(e) => {
                                                    field.onChange(e.target.checked);
                                                    setValue('allowStratEndTimeEachDay', !e.target.checked);
                                                }}
                                            />
                                            <div className={styles.radioCheckmark}></div>
                                            <div className={styles.radioLabel}>Allow Access for Entire Timeblock</div>
                                        </label>
                                    </div>
                                )}
                            />
                        </div>
                    </div>

                    {/* Start Date and End Date */}
                    <div className={styles.row}>
                        <div className={styles.fieldWrapper}>
                            <div className={styles.datestyling}>
                                <label>
                                    Start Date
                                    <span className={styles.astrikSign}> *</span>
                                </label>
                                <div className={`${styles.dateInputWrapper} datePicker-wrapper`}>
                                    <Controller
                                        name="startDate"
                                        control={control}
                                        rules={{ required: 'Start date is required' }}
                                        render={({ field }) => (
                                            <DatePicker
                                                selected={vendorAppointmentDateToDate(field.value)}
                                                onChange={(date) => {
                                                    field.onChange(date ? moment(date).format(DISPLAY_DATE_FORMAT) : null);
                                                    if (date) {
                                                        trigger('startDate');
                                                        if (watch('endDate')) trigger('endDate');
                                                        if (watch('startTime')) trigger('startTime');
                                                    }
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key.toLowerCase() === 'delete' || e.key.toLowerCase() === 'backspace') {
                                                        field.onChange(null);
                                                    }
                                                    e.preventDefault()
                                                }}
                                                dateFormat="MM-dd-yyyy"
                                                placeholderText="Select Start Date"
                                                minDate={new Date()}
                                                // className={`${styles.datePickerInput} ${errors.startDate ? styles.errorInput : ''}`}
                                                className={`${styles.customDatePicker} custom-dateInput`}
                                            />
                                        )}
                                    />
                                    {errors?.startDate?.message && <p className={styles.errorMsg}>{errors?.startDate?.message}</p>}
                                </div>
                            </div>
                        </div>
                        <div className={styles.fieldWrapper}>
                            <div className={styles.datestyling}>
                                <label>
                                    End Date
                                    <span className={styles.astrikSign}> *</span>
                                </label>
                                <div className={`${styles.dateInputWrapper} datePicker-wrapper`}>
                                    <Controller
                                        name="endDate"
                                        control={control}
                                        rules={{
                                            required: 'End date is required',
                                            validate: {
                                                isAfterOrSame: (value) => {
                                                    const startDate = watch('startDate');
                                                    if (!startDate || !value) return true;

                                                    const start = parseVendorAppointmentDate(startDate);
                                                    const end = parseVendorAppointmentDate(value);
                                                    if (!start || !end) return true;

                                                    return end.isSameOrAfter(start, 'day') || 'End date must be same or after start date';
                                                },
                                            },
                                        }}
                                        render={({ field }) => {
                                            const startDate = watch('startDate');

                                            // ✅ Minimum end date = startDate (if selected) or today
                                            const minDate = vendorAppointmentDateToDate(startDate) || new Date();

                                            const endDateValue =
                                                vendorAppointmentDateToDate(field.value);

                                            return (
                                                <DatePicker
                                                    selected={endDateValue}
                                                    onChange={(date) => {
                                                        if (!date) return;
                                                        const formattedDate = moment(date).format(DISPLAY_DATE_FORMAT);
                                                        setValue('endDate', formattedDate, { shouldValidate: true });
                                                        trigger('endDate');
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key.toLowerCase() === 'delete' || e.key.toLowerCase() === 'backspace') {
                                                            field.onChange(null);
                                                        }
                                                        e.preventDefault()
                                                    }}
                                                    minDate={minDate} // ✅ ensures endDate >= startDate or today
                                                    dateFormat="MM-dd-yyyy"
                                                    placeholderText="Select End Date"
                                                    // className={`${styles.datePickerInput} ${errors.endDate ? styles.errorInput : ''}`}
                                                    className={`${styles.customDatePicker} custom-dateInput`}
                                                />
                                            );
                                        }}
                                    />

                                    {errors?.endDate?.message && <p className={styles.errorMsg}>{errors.endDate.message}</p>}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Start Time and End Time - Accordion Effect */}
                    <div className={`${styles.row} ${styles.timeFieldsSection}`}>
                        <div className={styles.fieldWrapper}>
                            <div className={styles.datestyling}>
                                <label>Start Time<span className={styles.astrikSign}> *</span>
                                </label>
                                <div className={`${styles.dateInputWrapper} datePicker-wrapper`}>
                                    <Controller
                                        name="startTime"
                                        control={control}
                                        rules={{
                                            required: 'Start time is required',
                                            validate: (value) => {
                                                if (!value) return 'Start time is required';

                                                const selectedDate = parseVendorAppointmentDate(getValues("startDate"));
                                                const today = moment();

                                                // 🟢 Ensure future time if startDate is today
                                                if (selectedDate?.isSame(today, "day")) {
                                                    const selectedTime = moment(value, "hh:mm a");
                                                    if (selectedTime.isSameOrBefore(today, "minute")) {
                                                        return "Start time must be in the future";
                                                    }
                                                }

                                                // Validate based on allowEntireTimeBlock
                                                if (allowEntireTimeBlock && startDate && endDate) {
                                                    const startDateMoment = parseVendorAppointmentDate(startDate);
                                                    const endDateMoment = parseVendorAppointmentDate(endDate);
                                                    if (!startDateMoment || !endDateMoment) return true;
                                                    const isSameDay = startDateMoment.isSame(endDateMoment, 'day');

                                                    if (isSameDay && endTime) {
                                                        const startTimeMoment = moment(value, 'hh:mm a');
                                                        const endTimeMoment = moment(endTime, 'hh:mm a');
                                                        const diffInMinutes = endTimeMoment.diff(startTimeMoment, 'minutes');
                                                        if (diffInMinutes < 60) {
                                                            return 'Time difference must be at least 1 hour for same day';
                                                        }
                                                    }
                                                }

                                                // Validate based on allowStratEndTimeEachDay
                                                // if (allowStratEndTimeEachDay && endTime) {
                                                //     const startTimeMoment = moment(value, 'hh:mm a');
                                                //     const endTimeMoment = moment(endTime, 'hh:mm a');
                                                //     const diffInMinutes = endTimeMoment.diff(startTimeMoment, 'minutes');
                                                //     if (diffInMinutes < 60) {
                                                //         return 'Time difference must be at least 1 hour';
                                                //     }
                                                // }

                                                return true;
                                            }
                                        }}
                                        render={({ field }) => {
                                            return (
                                                <DatePicker
                                                    selected={field.value ? moment(field.value, 'hh:mm a').toDate() : null}
                                                    onChange={(date) => {
                                                        if (date) {
                                                            field.onChange(moment(date).format('hh:mm a'));
                                                            trigger('startTime');
                                                        }
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key.toLowerCase() === 'delete' || e.key.toLowerCase() === 'backspace') {
                                                            field.onChange(null);
                                                        }
                                                        e.preventDefault()
                                                    }}
                                                    showTimeSelect
                                                    showTimeSelectOnly
                                                    timeIntervals={60}
                                                    timeCaption="Time"
                                                    dateFormat="hh:mm a"
                                                    placeholderText="Select Start Time"
                                                    className={`${styles.customDatePicker} custom-dateInput`}
                                                    minTime={
                                                        watch('startDate') &&
                                                            parseVendorAppointmentDate(watch('startDate'))?.isSame(moment(), 'day')
                                                            ? moment().startOf('hour').add(1, 'hour').toDate() // ✅ prevent past today
                                                            : new Date(0, 0, 0, 0, 0)
                                                    }
                                                    maxTime={new Date(0, 0, 0, 23, 30)}
                                                    filterTime={filterTimeSlots}
                                                    excludeTimes={[]}
                                                />
                                            );
                                        }}
                                    />
                                    {errors?.startTime?.message && <p className={styles.errorMsg}>{errors?.startTime?.message}</p>}
                                </div>
                            </div>
                        </div>
                        <div className={styles.fieldWrapper}>
                            <div className={styles.datestyling}>
                                <label>End Time<span className={styles.astrikSign}> *</span></label>
                                <div className={`${styles.dateInputWrapper} datePicker-wrapper`}>
                                    <Controller
                                        name="endTime"
                                        control={control}
                                        rules={{
                                            required: 'End time is required',
                                            validate: (value) => {
                                                if (!value) return 'End time is required';

                                                // Validate based on allowEntireTimeBlock
                                                if (allowEntireTimeBlock && startDate && endDate) {
                                                    const startDateMoment = parseVendorAppointmentDate(startDate);
                                                    const endDateMoment = parseVendorAppointmentDate(endDate);
                                                    if (!startDateMoment || !endDateMoment) return true;
                                                    const isSameDay = startDateMoment.isSame(endDateMoment, 'day');

                                                    if (isSameDay && startTime) {
                                                        const startTimeMoment = moment(startTime, 'hh:mm a');
                                                        const endTimeMoment = moment(value, 'hh:mm a');
                                                        const diffInMinutes = endTimeMoment.diff(startTimeMoment, 'minutes');
                                                        if (diffInMinutes < 60) {
                                                            return 'Time difference must be at least 1 hour for same day';
                                                        }
                                                    }
                                                }

                                                // Validate based on allowStratEndTimeEachDay
                                                if (allowStratEndTimeEachDay && startTime) {
                                                    const startTimeMoment = moment(startTime, 'hh:mm a');
                                                    const endTimeMoment = moment(value, 'hh:mm a');
                                                    const diffInMinutes = endTimeMoment.diff(startTimeMoment, 'minutes');
                                                    if (diffInMinutes < 60) {
                                                        return 'Time difference must be at least 1 hour';
                                                    }
                                                }

                                                return true;
                                            }
                                        }}
                                        render={({ field }) => {
                                            return (
                                                <DatePicker
                                                    selected={field.value ? moment(field.value, 'hh:mm a').toDate() : null}
                                                    onChange={(date) => {
                                                        if (date) {
                                                            setValue('endTime', moment(date).format('hh:mm a'), { shouldValidate: true });
                                                            trigger('endTime');
                                                        }
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key.toLowerCase() === 'delete' || e.key.toLowerCase() === 'backspace') {
                                                            field.onChange(null);
                                                        }
                                                        e.preventDefault()
                                                    }}
                                                    className={`${styles.customDatePicker} custom-dateInput`}
                                                    showTimeSelect
                                                    showTimeSelectOnly
                                                    timeIntervals={60}
                                                    timeCaption="Time"
                                                    dateFormat="hh:mm a"
                                                    placeholderText="Select End Time"
                                                    minTime={
                                                        startDate &&
                                                            startTime &&
                                                            endDate &&
                                                            parseVendorAppointmentDate(endDate)?.isSame(parseVendorAppointmentDate(startDate), 'day')
                                                            ? moment(`${formatVendorAppointmentDateForApi(startDate)} ${startTime}`, `${API_DATE_FORMAT} hh:mm a`)
                                                                .add(1, 'hour')
                                                                .toDate() // ✅ after StartTime
                                                            : new Date(0, 0, 0, 0, 0)
                                                    }
                                                    maxTime={new Date(0, 0, 0, 23, 30)}
                                                    filterTime={filterEndTimeSlots}
                                                    excludeTimes={[]}
                                                />
                                            );
                                        }}
                                    />
                                    {errors?.endTime?.message && <p className={styles.errorMsg}>{errors.endTime.message}</p>}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={styles.row}>
                        <div className={`${styles.fieldWrapper} ${styles.lockerWrapper}`}>
                            <label>Select Locker</label>
                            <span className={styles.astrikSign}> *</span>
                            <div className={styles.fieldWrapperValue}>
                                <Controller
                                    name="locker"
                                    control={control}
                                    rules={{
                                        required: 'Please select a locker',
                                    }}
                                    render={({ field }) => {
                                        const options = (availableLockers || [])
                                            .map((lockerId) => ({
                                                label: `Locker ${lockerId}`,
                                                value: String(lockerId),
                                            }))
                                            .sort((a, b) => Number(a.value) - Number(b.value)); // Sorting by numeric value of 'lockerId'
                                        const handleLockerDropdownClick = () => {
                                            const missingFields = [];

                                            if (!startDate) missingFields.push('Start Date');
                                            if (!startTime) missingFields.push('Start Time');
                                            if (!endDate) missingFields.push('End Date');
                                            if (!endTime) missingFields.push('End Time');

                                            if (missingFields.length > 0) {
                                                setMissingFieldsMessage(`Please select ${missingFields.join(', ')} to get available lockers`);
                                                return false; // Prevent dropdown from opening
                                            }
                                            return true;
                                        };

                                        return (
                                            <Select
                                                className={styles.lockerSelect}
                                                isLoading={lockerDataLoading}
                                                placeholder="Select Locker"
                                                options={options}
                                                isDisabled={lockerDataLoading}
                                                isMulti={false}
                                                value={options.find((option) => option.value === field.value) || null}
                                                onChange={(selected) => field.onChange(selected ? selected.value : null)}
                                                onMenuOpen={handleLockerDropdownClick}
                                                styles={colourStyles}
                                                classNamePrefix="custom-react-select"
                                                maxMenuHeight={180}
                                            />
                                        );
                                    }}
                                />
                                {errors?.locker?.message && <p className={styles.errorMsg}>{errors?.locker?.message}</p>}
                            </div>
                        </div>
                    </div>
                    <div className={styles.fieldWrapperNoteName}>
                        <Controller
                            name="vendorSpecialNote"
                            control={control}
                            render={({ field }) => (
                                <TextArea
                                    label="Notes"
                                    placeholder="Enter notes"
                                    {...field}
                                    onChange={(e) => handleTrimStartChange(e, field.onChange)}
                                />
                            )}
                        />
                    </div>

                    {/* <div className={styles.fieldWrapperNoteName}>
                        <Controller
                            name="hasLockerAccess"
                            control={control}
                            render={({ field }) => (
                                <div className={styles.checkboxContainer}>
                                    <label className={styles.checkbox}>
                                        <input type="checkbox" checked={field.value} onChange={(e) => field.onChange(e.target.checked)} />
                                        <div className={styles.checkboxCheckmark}></div>
                                        <div className={styles.checkboxLabel}>Locker Access</div>
                                    </label>
                                </div>
                            )}
                        />
                    </div> */}
                    <div className={styles.btnUploadContainer}>
                        <button type="button" className={`${styles.btnUpload} ${styles.reset}`} onClick={closeModal}>
                            Cancel
                        </button>
                        <button type="submit" className={`${styles.btnUpload} ${styles.success}`} disabled={!errors}>
                            {isEditMode ? 'Update' : 'Create'}
                        </button>
                    </div>
                </form>
            </div>

            {missingFieldsMessage && (
                <div style={{
                    position: 'fixed',
                    top: '120px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: 'rgba(0,0,0,0.8)',
                    color: 'white',
                    padding: '12px 16px',
                    borderRadius: '8px',
                    zIndex: 1000,
                    transition: 'opacity 0.3s ease',
                    textAlign: 'center',
                    maxWidth: '300px',
                    width: '100%',
                }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, justifyContent: 'center' }}>
                        <p>{missingFieldsMessage}</p>
                    </div>
                </div>
            )}

        </div>
    );
}

export default AddVendorsAppointment
